import moment from 'moment'

export default {
  methods: {
    formatNumber: (n,decimals = 0) => {
      n = Number(n)
      return n.toLocaleString('en-US', { style: 'decimal', maximumFractionDigits : decimals, minimumFractionDigits : decimals })
    },
    formatDate (date,format = 'L') {
      moment.locale('es'); 
      return moment(date).format(format)
    },
  }
}
